import Twig from 'twig'

Twig.cache()

function replaceAll(string, search, replace) {
  // Escape possible regular expression syntax
  const searchEscaped = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

  return string.replace(new RegExp(searchEscaped, 'g'), replace)
}

// Override nl2br because it does html escaping
Twig.extendFilter('nl2br', function (value) {
  if (value === undefined || value === null || value === '') {
    return
  }

  const linebreakTag = 'BACKSLASH_n_replace'
  const br = '<br />' + linebreakTag

  value = value.replace(/\r\n/g, br).replace(/\r/g, br).replace(/\n/g, br)

  return replaceAll(value, linebreakTag, '\n')
})
